import React from 'react';
import { Col } from 'reactstrap';
import { displayValue } from '../../helper';

const SubtotalCols = (props) => {

    // For villa flat fees, show the exact total cost without "x attendees" multiplier
    // since the property is rented as a whole, not per person
    if (props.villaSubtotal !== undefined) {
        return(
            <React.Fragment>
                <Col lg="1">
                    {/* No multiplier for flat property rental */}
                </Col>
                <Col lg="2">
                    <p>
                        {props.currency}{displayValue(props.villaSubtotal)}
                    </p>
                </Col>
            </React.Fragment>
        )
    }

    return(
        <React.Fragment>
            <Col lg="1">
                x {props.attendees}
            </Col>
            <Col lg="2">
                <p>
                    {props.currency}{displayValue(props.costper * props.attendees)}
                </p>
            </Col>
        </React.Fragment>
    )
}

export default SubtotalCols;